import { createGlobalStyle } from 'styled-components'

import { font, headerFont, textSizeM } from '@/styles/theme/fonts.ts'

export const GlobalStyle = createGlobalStyle`
  * {
    box-sizing: border-box;
    padding: 0;
    margin: 0;
  }

  html,
  body {
    ${textSizeM};
    max-width: 100vw;
    overflow-x: hidden;
    font-weight: 400;
    font-family: ${font};
  }
  
  body {
    h1, h2 {
      font-family: ${headerFont};
    }
  }

  body p {
    ${textSizeM};
  }

  body ul {
    list-style-type: none;
  }

  button, input, textarea {
    all: unset;
    box-sizing: border-box;
    cursor: pointer;
  }

  img {
    all: unset;
    overflow: hidden;
  }

  body svg {
    height: 24px;
    width: 24px;
  }

  input, textarea {
    ${textSizeM};
    font-weight: 300;
    font-family: ${font};
  }
`
